import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import React from "react";

import { ComparisonRowData } from "../types";

export const buildComparisonColumns = (
  currentVersion: number
): Array<WSTableColumn<ComparisonRowData>> => [
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: "Versions" }
    },
    renderFunction: ({ data }) => <WSTableCell text={data.label} />
  },
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: `Current v${currentVersion}` }
    },

    renderFunction: ({ data }) => (
      <WSTableCell
        disabled={data.disabledCurrent}
        secondaryText={data.secondaryCurrentValue}
        text={data.currentValue}
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: `New v${currentVersion + 1}` }
    },
    renderFunction: ({ data }) => (
      <WSTableCell
        disabled={data.disabledNew}
        secondaryText={data.secondaryNewValue}
        text={data.newValue}
      />
    )
  }
];
